import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import TrackSubmission from "./pages/TrackSubmission";
import DishaForm from "./pages/questionnaire/DishaForm";
import NitiForm from "./pages/questionnaire/NitiForm";
import SamvadForm from "./pages/questionnaire/SamvadForm";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import SubmissionDetail from "./pages/admin/SubmissionDetail";
import AdminBlog from "./pages/admin/AdminBlog";
import ChatWidget from "./components/ChatWidget";
import SmoothScroll from "./components/SmoothScroll";
import Preloader from "./components/Preloader";
import CustomCursor from "./components/CustomCursor";
import ScrollProgress from "./components/ScrollProgress";

function App() {
    const path = typeof window !== "undefined" ? window.location.pathname : "/";
    const isAdmin = path.startsWith("/admin");

    const routes = (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/track" element={<TrackSubmission />} />
                <Route path="/questionnaire/disha" element={<DishaForm />} />
                <Route path="/questionnaire/niti" element={<NitiForm />} />
                <Route
                    path="/questionnaire/samvad"
                    element={<SamvadForm />}
                />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/blog" element={<AdminBlog />} />
                <Route
                    path="/admin/submission/:id"
                    element={<SubmissionDetail />}
                />
            </Routes>
            {!isAdmin && <ChatWidget />}
        </BrowserRouter>
    );

    return (
        <div className="App">
            {!isAdmin && (
                <>
                    <Preloader />
                    <ScrollProgress />
                    <CustomCursor />
                </>
            )}
            {isAdmin ? routes : <SmoothScroll>{routes}</SmoothScroll>}
            <Toaster
                position="top-right"
                richColors
                toastOptions={{
                    style: { fontFamily: "Outfit, sans-serif" },
                }}
            />
        </div>
    );
}

export default App;
